import { httpClient } from '@/services/http/httpClient'

type ToggleIdeaTagParams = {
  ideaId: string
  tagId: string
}

export async function toggleIdeaTag({
  ideaId,
  tagId,
}: ToggleIdeaTagParams): Promise<void> {
  await httpClient.post(`/ideas/ai/tags/${tagId}/link/${ideaId}`)
}
